import React from 'react';

import { Tooltip } from '@shared/components/ui';

interface CollapsedRowTooltipProps {
  isCollapsed: boolean;
  label: string;
  children: React.ReactNode;
}

/**
 * Wraps a collapsed (icon-only) nav row in a right-placed floating tooltip so the
 * item's name appears on hover — mirroring the email action rail. When expanded the
 * label is already visible, so the row is rendered bare.
 */
const CollapsedRowTooltip: React.FC<CollapsedRowTooltipProps> = ({
  isCollapsed,
  label,
  children,
}) =>
  isCollapsed ? (
    <Tooltip content={label} placement="right" className="flex w-full">
      {children}
    </Tooltip>
  ) : (
    <>{children}</>
  );

export default CollapsedRowTooltip;
